/**
 * @generated SignedSource<<aeab19412c3a97981e1a0c8d007b9ef0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ResolutionCell$data = {
  readonly id: string;
  readonly resolution: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ResolutionCell";
};
export type ResolutionCell$key = {
  readonly " $data"?: ResolutionCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ResolutionCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ResolutionCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraResolutionField"
};

(node as any).hash = "4449f0b7b9830682d20e8224a7da5b31";

export default node;
